// frontend/packages/business-console/src/hooks/useDebouncedValue.js
//
// Hold a fast-changing value (a search box) still for `delay` ms so effects
// keyed on it fire once the user stops typing instead of once per keystroke.
//
// The media library and the media picker both refetch whenever their search
// term changes. Without this, typing "hero" fired four list requests and
// flipped the grid into its loading state four times, and the responses could
// land out of order and paint a stale result.

import { useEffect, useState } from 'react';

export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
